import React from 'react';
import PageHeading from '@components/PageHeading';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { HeadingProps } from './types';

const Heading = (props: HeadingProps) => {
  const { heading, highlightedText } = props;
  return (
    <PageHeading
      className={ivclass(
        'iv-text-grey-85',
        'iv-text-heading-s md:iv-text-heading-4xl lg:iv-text-heading-4xl xl:iv-text-heading-5xl',
        'iv-m-heading-s md:iv-m-heading-4xl lg:iv-m-heading-4xl xl:iv-m-heading-5xl',
        'iv-font-extrabold',
      )}
    >
      <span className={ivclass('iv-block', 'iv-text-gradient-green')}>
        {highlightedText}
      </span>
      <span className={ivclass('lg:iv-block xl:iv-block')}>{heading}</span>
    </PageHeading>
  );
};

export default Heading;
